/*
     Title: Constant for CUT_PLAN
     Description: Constant for CUT_PLAN
     Author: Iqbal Hossain
     Date: 18-January-2022
     Modified: 18-January-2022
*/

export const FETCH_CUT_PLAN = 'FETCH_CUT_PLAN';
export const FETCH_CUT_PLAN_BY_QUERY = 'FETCH_CUT_PLAN_BY_QUERY';
export const ADD_CUT_PLAN = 'ADD_CUT_PLAN';
export const DELETE_CUT_PLAN = 'DELETE_CUT_PLAN';
export const FETCH_CUT_PLAN_BY_ID = 'FETCH_CUT_PLAN_BY_ID';
export const UPDATE_CUT_PLAN = 'UPDATE_CUT_PLAN';
export const DELETE_CUT_PLAN_BY_RANGE = 'DELETE_CUT_PLAN_BY_RANGE';

/** Change Log
 * 18-Jan-2022(Iqbal): Add TOGGLE_CUT_PLAN_SIDEBAR, FETCH_CUT_PLAN_BY_QUERY, ADD_CUT_PLAN, DELETE_CUT_PLAN, FETCH_CUT_PLAN_BY_ID, UPDATE_CUT_PLAN, DELETE_CUT_PLAN_BY_RANGE
 */
